const DEFAULT_FRONTEND_ORIGIN = process.env.DEFAULT_FRONTEND_ORIGIN ?? 'http://localhost:4200';

// Only ever resolve to an origin we recognise — localhost (any dev port) or a
// *.forgestack.in subdomain — so a crafted candidate origin can't turn a
// redirect (Google OAuth) or a reset link (password reset) into an open
// redirect / phishing vector.
export function resolveFrontendOrigin(candidate: string | undefined): string {
  if (candidate && /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(candidate)) {
    return candidate;
  }
  if (candidate && /^https:\/\/[a-z0-9-]+\.forgestack\.in$/i.test(candidate)) {
    return candidate;
  }
  return DEFAULT_FRONTEND_ORIGIN;
}
